import React, { forwardRef } from 'react'
import { Icon, iconDefaultProps, IconProps } from '../Icon'

type Scan02IconProps = IconProps

const Scan02Icon = forwardRef<SVGSVGElement, Scan02IconProps>(
  (props: Scan02IconProps, ref) => (
    <Icon {...props} ref={ref}>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M8 3h-.2c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8V8m5 13h-.2c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.72 3 17.88 3 16.2V16m18-8v-.2c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 3 17.88 3 16.2 3H16m5 13v.2c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C18.72 21 17.88 21 16.2 21H16"
        fill="none"
      ></path>
      <path
        fill="currentColor"
        d="M7.35 7.8a.8.8 0 1 1 1.6 0v2.004a.196.196 0 0 1-.196.196H7.546a.196.196 0 0 1-.196-.196V7.8Zm7.65 0a.8.8 0 0 1 1.6 0v2.004a.196.196 0 0 1-.196.196h-1.208A.196.196 0 0 1 15 9.804V7.8Zm-2.55 0a.8.8 0 0 1 1.6 0v2.004a.196.196 0 0 1-.196.196h-1.207a.196.196 0 0 1-.197-.196V7.8Zm-2.55 0a.8.8 0 0 1 1.6 0v2.004a.196.196 0 0 1-.196.196h-1.208a.196.196 0 0 1-.196-.196V7.8Z"
        stroke="none"
      ></path>
      <rect
        width="14"
        height="1.6"
        x="5"
        y="11.2"
        fill="currentColor"
        rx=".8"
        stroke="none"
      ></rect>
      <rect
        width="1.6"
        height="5"
        x="7.35"
        y="12"
        fill="currentColor"
        rx=".8"
        stroke="none"
      ></rect>
      <rect
        width="1.6"
        height="5"
        x="9.9"
        y="12"
        fill="currentColor"
        rx=".8"
        stroke="none"
      ></rect>
      <rect
        width="1.6"
        height="5"
        x="12.45"
        y="12"
        fill="currentColor"
        rx=".8"
        stroke="none"
      ></rect>
      <rect
        width="1.6"
        height="5"
        x="15"
        y="12"
        fill="currentColor"
        rx=".8"
        stroke="none"
      ></rect>
    </Icon>
  ),
)

Scan02Icon.displayName = 'Scan02Icon'
Scan02Icon.defaultProps = iconDefaultProps

export type { Scan02IconProps }
export { Scan02Icon }
